export const bellImage = (isActive, isAnimated, withDot) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="21"
    viewBox="0 0 24 21"
    className={isAnimated ? 'animated' : ''}
  >
    <path
      fill={isActive ? '#6AA6EB' : '#A2A4B2'}
      fillRule="nonzero"
      d={`M21 13c-1.1 0-2-.9-2-2V7c0-3.9-3.1-7-7-7S5 
        3.1 5 7v4c0 1.1-.9 2-2 2-.8 0-1.6.3-2.1.9-.6.5-.9 
        1.3-.9 2.1 0 1.7 1.3 3 3 3h6.2c.4 1.2 1.5 2 2.8 2 1.3 0 2.4-.8 
        2.8-2H21c1.7 0 3-1.3 3-3s-1.3-3-3-3zm0 
        4H3c-.6 0-1-.4-1-1 0-.3.1-.5.3-.7.2-.2.4-.3.7-.3 2.2 0 4-1.8 
        4-4V7c0-2.8 2.2-5 5-5s5 2.2 5 5v4c0 2.2 1.8 4 4 4 .6 0 1 .4 1 
        1s-.4 1-1 1z`}
    />
    {withDot && <rect width="8" height="8" x="16" fill="#E34D57" rx="4" />}
  </svg>
);

export const hourglassImage = (color = '#6AA6EB') => (
  <svg xmlns="http://www.w3.org/2000/svg" width="27" height="36" viewBox="0 0 27 36">
    <g fill="none" fillRule="evenodd">
      <path d="M-4 0h36v36H-4z" />
      <path
        fill={color}
        fillRule="nonzero"
        d={`M0 0v3h27V0H0zm0 36h27v-3h-6l-7.5-6L6 33H0v3zm3-1.5h3v-9.75l4.8-3.15-2.7-1.8L3 
        23.25V34.5zm0-33v11.25l18 
        12v9.75h3V23.25L16.2 18l7.8-5.25V1.5h-3v9.75l-7.5 4.95L6 11.25V1.5H3z`}
      />
    </g>
  </svg>
);
